import { Grid } from "@mui/material";
import { debounce } from "lodash";
import React, { useCallback, useContext } from "react";
import { useDispatch, useSelector } from "react-redux";
import Checkbox from "../../../../framework/Checkbox";
import GlobalContext from "../../../../framework/GlobalContext";
import SelectInput from "../../../../framework/SelectInput";
import TextInput from "../../../../framework/TextInput";
import NumberInput from "../../../../framework/NumberInput";
import { storageOptions } from "../../../../utils/constant";
import { formStateHandler } from "../../../../utils/utils";

const MiscellaneousTab = (props) => {
  const { isAddIngredients } = props;
  const { setCurrentComponent } = useContext(GlobalContext);

  const dispatch = useDispatch();

  const { formState } = useSelector(
    (state) => state.commonReducer.common.addProduct
  );

  const dispatchFormState = useCallback(
    (newState) => {
      dispatch({
        type: "set_add_product_form_state",
        payload: newState,
      });
    },
    [dispatch]
  );

  // eslint-disable-next-line
  const debounceDispatchFormState = useCallback(
    debounce(dispatchFormState, 1),
    []
  );

  const handleFormChange = useCallback(
    (fieldName, fieldValue, isSelect = false, options) => {
      let newFormState = formStateHandler(
        formState,
        fieldName,
        fieldValue,
        isSelect,
        options
      );
      debounceDispatchFormState(newFormState);
    },
    [debounceDispatchFormState, formState]
  );

  return (
    <>
      {!isAddIngredients && (
        <Grid
          container
          spacing={2}
          sx={{ margin: "5px 0px 5px -10px", width: "100%" }}
        >
          <Grid item xs={1.5}>
            <Checkbox
              id="add_product_is_banned"
              name="addProdductIsBanned"
              label="Lock PO/Purchase"
              onChange={(e) => {
                handleFormChange("isBanned", e.target.checked);
              }}
              checked={formState?.isBanned}
              onFocus={() => {
                setCurrentComponent("add_product_is_banned");
              }}
              inputProps={{
                "data-markers": JSON.stringify({
                  up: "add_product_is_banned",
                  down: "add_product_block_expiry_print",
                  left: "add_product_is_banned",
                  right: "add_product_is_returnable",
                }),
              }}
              autoFocus
            />
          </Grid>
          <Grid item xs={1.5}>
            <Checkbox
              id="add_product_is_returnable"
              name="addProductIsReturnable"
              label="Is Returnable"
              onChange={(e) => {
                handleFormChange("isReturnable", e.target.checked);
              }}
              checked={formState?.isReturnable}
              onFocus={() => {
                setCurrentComponent("add_product_is_returnable");
              }}
              inputProps={{
                "data-markers": JSON.stringify({
                  up: "add_product_is_returnable",
                  down: "add_product_allow_on_web",
                  left: "add_product_is_banned",
                  right: "add_product_locked",
                }),
              }}
            />
          </Grid>
          <Grid item xs={1}>
            <Checkbox
              id="add_product_locked"
              name="addProductLocked"
              label="Lock"
              onChange={(e) => {
                handleFormChange("isDiscontinued", e.target.checked);
              }}
              checked={formState?.isDiscontinued}
              onFocus={() => {
                setCurrentComponent("add_product_locked");
              }}
              inputProps={{
                "data-markers": JSON.stringify({
                  up: "add_product_locked",
                  down: "add_product_storage",
                  left: "add_product_is_returnable",
                  right: "add_product_is_undeliverable",
                }),
              }}
            />
          </Grid>
          <Grid item xs={1.5}>
            <Checkbox
              id="add_product_is_undeliverable"
              name="addProductIsUndeliverable"
              label="Is Undeliverable"
              onChange={(e) => {
                handleFormChange("isUndeliverable", e.target.checked);
              }}
              checked={formState?.isUndeliverable}
              onFocus={() => {
                setCurrentComponent("add_product_is_undeliverable");
              }}
              inputProps={{
                "data-markers": JSON.stringify({
                  up: "add_product_is_undeliverable",
                  down: "add_product_storage",
                  left: "add_product_locked",
                  right: "add_product_is_active",
                }),
              }}
            />
          </Grid>
          <Grid item xs={1.2}>
            <Checkbox
              id="add_product_is_active"
              name="addProductIsActive"
              label="Is Active"
              onChange={(e) => {
                handleFormChange("isActive", e.target.checked);
              }}
              checked={formState?.isActive}
              onFocus={() => {
                setCurrentComponent("add_product_is_active");
              }}
              inputProps={{
                "data-markers": JSON.stringify({
                  up: "add_product_is_active",
                  down: "add_product_storage",
                  left: "add_product_is_undeliverable",
                  right: "add_product_disable_auto_barcode",
                }),
              }}
            />
          </Grid>
          <Grid item xs={1.8}>
            <Checkbox
              id="add_product_disable_auto_barcode"
              name="addProductDisableAutoBarcode"
              label="Disable Auto Barcode"
              onChange={(e) => {
                handleFormChange(
                  "disableAutoBarcodePrinting",
                  e.target.checked
                );
              }}
              checked={formState?.disableAutoBarcodePrinting}
              onFocus={() => {
                setCurrentComponent("add_product_disable_auto_barcode");
              }}
              inputProps={{
                "data-markers": JSON.stringify({
                  up: "add_product_disable_auto_barcode",
                  down: "add_product_storage",
                  left: "add_product_is_active",
                  right: "add_product_skip_from_apo",
                }),
              }}
            />
          </Grid>
          <Grid item xs={1.5}>
            <Checkbox
              id="add_product_skip_from_apo"
              name="addProductSkipFromAPO"
              label="Skip from APO"
              onChange={(e) => {
                handleFormChange("skipFromApo", e.target.checked);
              }}
              checked={formState?.skipFromApo}
              onFocus={() => {
                setCurrentComponent("add_product_skip_from_apo");
              }}
              inputProps={{
                "data-markers": JSON.stringify({
                  up: "add_product_skip_from_apo",
                  down: "add_product_storage",
                  left: "add_product_disable_auto_barcode",
                  right: "add_product_skip_from_short_book",
                }),
              }}
            />
          </Grid>
          <Grid item xs={1.6}>
            <Checkbox
              id="add_product_skip_from_short_book"
              name="addProductSkipFromShortBook"
              label="Skip from Short Book"
              onChange={(e) => {
                handleFormChange("skipFromShortBook", e.target.checked);
              }}
              checked={formState?.skipFromShortBook}
              onFocus={() => {
                setCurrentComponent("add_product_skip_from_short_book");
              }}
              inputProps={{
                "data-markers": JSON.stringify({
                  up: "add_product_is_banned",
                  down: "add_product_storage",
                  left: "add_product_skip_from_apo",
                  right: "add_product_block_expiry_print",
                }),
              }}
            />
          </Grid>
          <Grid item xs={1.5}>
            <Checkbox
              label="Block Expiry Print"
              id="add_product_block_expiry_print"
              name="addProductBlockExpiryPrint"
              onChange={(e) => {
                handleFormChange("blockExpiryPrint", e.target.checked);
              }}
              checked={formState?.blockExpiryPrint}
              onFocus={() => {
                setCurrentComponent("add_product_block_expiry_print");
              }}
              inputProps={{
                "data-markers": JSON.stringify({
                  up: "add_product_is_banned",
                  down: "add_product_remarks",
                  left: "add_product_skip_from_short_book",
                  right: "add_product_allow_on_web",
                }),
              }}
            />
          </Grid>
          <Grid item xs={1.5}>
            <Checkbox
              id="add_product_allow_on_web"
              label="Allow on Web"
              name="addProductAllowOnWeb"
              onChange={(e) => {
                handleFormChange("allowWeb", e.target.checked);
              }}
              checked={formState?.allowWeb}
              onFocus={() => {
                setCurrentComponent("add_product_allow_on_web");
              }}
              inputProps={{
                "data-markers": JSON.stringify({
                  up: "add_product_is_returnable",
                  down: "add_product_remarks",
                  left: "add_product_block_expiry_print",
                  right: "add_product_storage",
                }),
              }}
            />
          </Grid>
          <Grid item xs={2}>
            <SelectInput
              id="add_product_storage"
              label="Storage"
              name="addProductStorage"
              onChange={(e, value) => {
                handleFormChange("storage", value);
              }}
              value={formState?.storage}
              onFocus={() => {
                setCurrentComponent("add_product_storage");
              }}
              options={storageOptions}
              isOptionEqualToValue={(option, value) => {
                return option.label === value.label;
              }}
              getOptionLabel={(option) => option.label}
              markers={JSON.stringify({
                up: "add_product_locked",
                down: "add_product_remarks",
                left: "add_product_allow_on_web",
                right: "add_product_remarks",
              })}
            />
          </Grid>
          <Grid item xs={12}>
            <TextInput
              id="add_product_remarks"
              name="addProductRemarks"
              label="Remarks"
              onChange={(e) => {
                handleFormChange("remarks", e.target.value);
              }}
              value={formState?.remarks}
              onFocus={() => {
                setCurrentComponent("add_product_remarks");
              }}
              maxInputLength={2000}
              inputProps={{
                "data-markers": JSON.stringify({
                  up: "add_product_block_expiry_print",
                  down: "add_product_remarks",
                  left: "add_product_storage",
                  right: "add_product_remarks",
                }),
              }}
            />
          </Grid>
        </Grid>
      )}
    </>
  );
};

export default MiscellaneousTab;
